<template>
  <div class="issue-upload-file">
    <div class="issue-upload-file__file issue-upload-file__file_image" v-if="canView" :style="{backgroundImage: imageSource}">

    </div>
    <div class="issue-upload-file__file issue-upload-file__file_file" v-else>
      <app-icon name="FileIcon"/>
    </div>

    <div class="issue-upload-file__info">
      <div class="issue-upload-file__name">{{file.name}}</div>
      <div class="issue-upload-file__size">{{size}}</div>
    </div>

    <div class="issue-upload-file__delete" @click="deleteFile">
      <app-icon name="TrashIcon" size="18px"/>
    </div>


  </div>
</template>

<script>
  const IAMGES_CAN_VIEW = [
    'jpg',
    'jpeg',
    'png',
    'gif'
  ];

  export default {
    name: "UploadFilesItem",
    props: {
      file: {}
    },
    computed: {
      canView(){
        let paths = this.file.name.split('.');
        return IAMGES_CAN_VIEW.includes((paths.pop()).toLowerCase());
      },
      imageSource(){
        let url = null;
        if(this.canView){
          url = `url(${URL.createObjectURL(this.file)})`;
        }
        return url;
      },
      size(){
        let bytes = this.file.size;
        let sizes = ['байт', 'Кбайт', 'Мбайт', 'Гбайт', 'Тбайт'];
        if (bytes === 0) return '0 байт';
        let i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
        return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
      }
    },
    methods: {
      deleteFile(){
        this.$emit('deleteFile');
      }
    }
  }
</script>

<style lang="scss">
  .issue-upload-file{
    display: flex;
    align-items: center;
    margin-bottom: 10px;

    &__file{
      margin-right: 15px;
      flex-shrink: 0;

      &_file{
        display: flex;
        background: rgba(var(--app-primary), 1);
        color: #fff;
        border-radius: 50%;
        align-items: center;
        justify-content: center;
        width: 40px;
        height: 40px;
      }

      &_image{
        width: 70px;
        height: 50px;
        background-position: center;
        background-size: contain;
        background-repeat: no-repeat;
        border-radius: 4px;
        box-shadow: 0 10px 12px rgba(0, 0, 0, .2);
        border: 1px solid rgba(0,0,0,.1);
      }
    }

    &__info{
      flex: 1;
    }

    &__file_file + &__info{
      max-width: calc(100% - 83px);
    }

    &__file_image + &__info{
      max-width: calc(100% - 113px);
    }

    &__name{
      line-height: 1;
      white-space: nowrap;
      overflow: hidden;
      margin-bottom: 5px;
      flex-shrink: 0;
      font-weight: 500;
    }

    &__size{
      font-size: .85rem;
      line-height: 1;
    }

    &__delete{
      display: flex;
      color: rgba(var(--app-danger), 1);
      margin-left: 10px;
      cursor: pointer;
    }
  }
</style>
